// Typed search params of the Curves gallery (Zod with .catch fallbacks): the document, search text, topic chips, the section priorities and an old ?curve= link that is redirected to the chart drawing that curve.
import { z } from "zod";

import { zChartTopic } from "@/api/__generated__/zod.gen";
import { optionalList, optionalString } from "@/app/search";
import { PRIORITIES } from "@/components/common/PriorityBadge";

export const curvesSearchSchema = z.object({
  doc: optionalString(),
  q: optionalString(),
  topic: optionalList(zChartTopic),
  priority: optionalList(z.enum(PRIORITIES)),
  curve: optionalString(),
});

export type CurvesSearch = z.output<typeof curvesSearchSchema>;

export type CurvesSearchPatch = { [K in keyof CurvesSearch]?: CurvesSearch[K] | undefined };

export const chartSearchSchema = z.object({
  doc: optionalString(),
});

export type ChartSearch = z.output<typeof chartSearchSchema>;
